/** 路由變更時遞增的快取 key */
export function useCacheKey() {
  const _cacheKey = ref<number>(0)

  const route = useRoute()

  const cacheKey = computed(() => _cacheKey.value)

  watch(
    () => route.fullPath,
    () => {
      _cacheKey.value++
    }
  )

  return {
    /** 當前快取版本號（路由變更時自動遞增） */
    cacheKey
  }
}
